export type UserOrganization = 'culturegenesis' | 'partner';

export const isAllowedDomain = (email: string | null | undefined): boolean => {
  if (!email) return false;
  const normalized = email.toLowerCase().trim();
  return (
    normalized.endsWith('@culturegenesis.com') ||
    normalized.endsWith('@culturegenesis-partnerships.com')
  );
};

export const orgFromEmail = (email: string | null | undefined): UserOrganization => {
  if (!email) return 'culturegenesis';
  const normalized = email.toLowerCase().trim();
  return normalized.endsWith('@culturegenesis-partnerships.com')
    ? 'partner'
    : 'culturegenesis';
};
